const graphQlErrors = require('../graphql/errors.graphql')
const FormError = require('./FormError')

class BaseErrorHandler {
  addError(key, message) {
    const error = new FormError(key, message);
    if (!Object.keys(this.errors).includes(error.key)) {
      this.errors = { ...this.errors, ...error.get() };
    }
  }

  get hasError() {
    return this.fieldErrors !== null || this.logicErrors !== null;
  }

  get fieldErrors() {
    return this.graphql.fieldErrors()
  }

  get logicErrors() {
    return this.graphql.logicErrors()
  }

  handle() {
    const fieldErrors = this.fieldErrors
    const logicErrors = this.logicErrors
    Promise.all(this.handler);

    if (fieldErrors !== null) {
      Object.keys(fieldErrors).forEach((key) => {
        this.addError(key, fieldErrors[key]);
      });
    }

    this.form.setErrors(this.errors);

    return {
      hasError: this.hasError,
      fieldErrors: {
        hasError: fieldErrors !== null,
        errors: fieldErrors,
      },
      logicErrors: {
        hasError: logicErrors !== null,
        errors: logicErrors,
      },
    };
  }

  constructor(err, form) {
    this.graphql = graphQlErrors(err);
    this.form = form;
    this.errors = {};
    this.handler = [];
  }
}

module.exports = BaseErrorHandler;